<template>
  <el-dialog
    v-if="!isMobile"
    class="sku-perview-dialog"
    :visible.sync="showDialog"
    width="100%"
    top="0"
    @opened="initSwiper"
    @close="restSwiper"
  >
    <div class="swiper">
      <div class="swiper-container-imgview">
        <div class="swiper-wrapper" style="display: flex">
          <div v-for="(item, index) in dataList || []" :key="index" class="swiper-slide">
            <GtImage
              class="imgDOM"
              :src="getUrlWithOss(item.valueImage, { w: 583, h: 710 })"
              :alt="item.valueName"
              aspect-ratio="121.7%"
              fit="contain"
            />
          </div>
        </div>
      </div>
      <div slot="pagination" class="imgview-pagination"></div>
      <!-- 如果需要导航按钮 -->
      <!--<div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>-->
    </div>
  </el-dialog>
  <van-popup
    v-else
    v-model="showDialog"
    class="mobile-perview-popup"
    :overlay-style="{ zIndex: 2100 }"
  >
    <i
      class="iconfont icon-close-line"
      style="font-size: 24px; position: fixed; top: 24px; right: 24px; z-index: 2"
      @click="showDialog = false"
    ></i>

    <GtSwiper ref="mySwiper" :data="dataList || []" :swiper-option="swiperOption">
      <div ref="swiperDom" slot="default" slot-scope="{ data }" class="swiper-detail">
        <img class="imgDOM" :src="getUrlWithOss(data.valueImage, {})" :alt="data.valueName" />
      </div>

      <div slot="pagination">
        <div class="swiper-button-next">
          <i class="iconfont icon-arrow-right"></i>
        </div>
        <div class="swiper-button-prev">
          <i class="iconfont icon-arrow-left"></i>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </GtSwiper>
  </van-popup>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min.js';
import 'swiper/swiper-bundle.css';
import { mapGetters } from 'vuex';
import { GtImage, GtSwiper } from '@speedshop/template';
import { Dialog } from 'element-ui';
import ossImage from '@/mixins/ossImage';

export default {
  name: 'ShippingBagDrawer',
  components: { GtImage, GtSwiper, ElDialog: Dialog },
  mixins: [ossImage],
  props: {
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    perviewIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    const self = this;
    return {
      showDialog: false,
      showImgIndex: 0,
      swiperOption: {
        spaceBetween: 0,
        slidesPerView: 1,
        loop: false,
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          slideChange() {
            self.showImgIndex = this.realIndex;
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters(['isGuest', 'isLogin', 'isMobile'])
  },
  watch: {
    dataList: {
      handler(val, old) {
        if (this.showDialog) {
          console.log(val, 'dataList');
        }
      },
      deep: true
    },
    showDialog: {
      handler(val, old) {
        if (!val) {
          // 关闭时 把当前展示的图片传给父组件触发修改选中的颜色
          this.$emit('rest-color', {
            item: this.dataList[this.showImgIndex],
            index: this.showImgIndex
          });
        } else {
          this.initMobileSwiper();
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (!this.isMobile) {
      this.restSwiper();
    }
  },
  mounted() {},
  methods: {
    initMobileSwiper() {
      this.$nextTick(() => {
        setTimeout(() => {
          const swiper = this.$refs.mySwiper && this.$refs.mySwiper?.swiper;
          if (swiper) {
            swiper && (swiper.params.initialSlide = this.perviewIndex);
            swiper.update();
            swiper.slideTo(this.perviewIndex);
          }
        }, 1000);
      });
    },
    initSwiper() {
      const _self = this;
      this.Swiper = new Swiper('.swiper-container-imgview', {
        initialSlide: _self.perviewIndex,
        spaceBetween: 20,
        slidesPerView: 1,
        direction: this.isMobile ? 'horizontal' : 'vertical',
        mousewheel: true,
        loop: false,
        pagination: {
          el: '.imgview-pagination',
          clickable: true
        },
        on: {
          slideChange(swiper) {
            console.log(this.realIndex, ' this.realIndex');
            _self.showImgIndex = this.realIndex;
          }
        }
      });
    },
    restSwiper() {
      // this.Swiper && this.Swiper.slideTo(1, 100, false);
    }
  }
};
</script>

<style lang="scss">
.sku-perview-dialog {
  .el-dialog__header,
  .el-dialog__body {
    background: #f0f0f0;
  }
}
</style>

<style lang="scss" scoped>
.images {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: var(--pdp-main-content-width);
  margin: 82px auto 0;
  //padding: 0 20px;
  width: 100%;
  .view {
    width: calc(50% - 8px);
    height: 710px;
    max-height: 750px;
    overflow: hidden;
    background-color: #f0f0f0;
    cursor: pointer;
    img {
      display: block;
      width: 90%;
      margin: 0 auto;
    }
  }
  .view:nth-child(n + 3) {
    margin-top: 16px;
  }

  ::v-deep .el-dialog__wrapper {
    z-index: 99 !important;
    top: 103px;
  }
  ::v-deep .is-fullscreen {
    background-color: #f0f0f0;
  }
  ::v-deep .el-dialog__header,
  ::v-deep .el-dialog__body {
    padding: 0;
  }
  ::v-deep .el-dialog__headerbtn {
    z-index: 99;
  }
}

.swiper {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  overflow: hidden;
}
.swiper-container-imgview {
  width: 100%;
  height: calc(100vh - 20px);
  background-color: #f0f0f0;
}
.swiper-wrapper {
  background-color: #f0f0f0;
}
.swiper-slide {
  text-align: center;
  line-height: 400px;
  color: #b0b0b0;
  background-color: #f0f0f0;
  padding: 10px 0;
  margin: auto;

  .imgDOM {
    width: auto;
    height: 100%;
  }
}
.imgview-pagination {
  position: absolute;
  width: 150px;
  top: 50px;
  transform: translate(-45px, 30px) rotate(90deg);
  text-align: left;
  z-index: 99;

  ::v-deep .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    margin: 0 3px !important;
  }
}

.mouse {
  position: fixed;
  right: 0;
  bottom: 0;
  flex-direction: column;
  width: 120px;
  height: 150px;
  background: #fff;
  justify-content: center;
}

.mobile-img {
  ::v-deep .el-dialog__wrapper {
    top: 0;
    z-index: 99999 !important;
  }
  .imgview-pagination {
    height: 50px;
    width: 100%;
    top: unset;
    bottom: 50px !important;
    transform: translate(0px, 30px) rotate(0deg);
    text-align: center;
  }
  .swiper-slide {
    display: flex;
    align-items: center;
  }
  .swiper-container-imgview {
    height: 100%;
    .imgDOM {
      width: 100%;
      margin: 0 auto;
    }
  }
}
.mobile-perview-popup {
  height: auto;
  width: 100%;
  z-index: 2200 !important;
  .imgDOM {
    width: 100%;
    height: 100%;
    background-color: #f0f0f0;
    aspect-ratio: 1/1.25;
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 52px !important;
    height: 52px !important;
    margin-top: 0px !important;
    border-radius: 50% !important;
    opacity: 1 !important;
    background-color: rgba(0, 0, 0, 0) !important;
    z-index: 99 !important;
    &::after {
      display: none;
    }
    color: var(--main-color-ua-dark-grey, #14141E);
  }
}
</style>
